














































































































import { qrs } from "@/shared/dtos/qrs";
import qrsModule from "@/store/modules/qrs-module";
import { Component, Vue, Watch } from "vue-property-decorator";
import Dynamic_table from "../dynamic_tables/dynamic_table.vue";

@Component({
  components: {
    Dynamic_table,
  },
})
export default class qrs_lista extends Vue {
  private dialog: boolean = false;
  private cantidad: number | null = 100;
  private generating: boolean = false;
  private progreso: number = 0; // porcentaje
  private mensaje: string = "";
  private errores: string[] = [];

  // Nuevo: propiedades para edición
  private editDialog: boolean = false;
  private editQrs: qrs | null = null;
  private editSaving: boolean = false;
  private editMensaje: string = "";

  async created() {
    await qrsModule.getqrses();
    try {
      const raw = this.$route && this.$route.query ? this.$route.query.code : null;
      const code = Array.isArray(raw) ? raw[0] : raw;
      if (!code) return;


      const list = qrsModule.qrses || [];
      const found = list.find((it: any) => String(it.code) === String(code));
      if (found) {
        // abrir edición en el siguiente tick para evitar problemas con render
        await this.$nextTick();
        this.editar_caja(found);
      }
    } catch (err) {
      console.error("Error al abrir edición por query.code:", err);
    }
  }
  get qrs() {
    return qrsModule.qrses;
  }

  // Abrir diálogo
  openGenerarDialog() {
    this.cantidad = 100; // valor por defecto opcional
    this.progreso = 0;
    this.mensaje = "";
    this.dialog = true;
  }

  @Watch("editQrs.prize_text", { immediate: true })
  onEditPrizeTextChanged(newVal: string | undefined) {
    if (!this.editQrs) return;
    this.editQrs.has_prize = !!(newVal && String(newVal).trim().length > 0);
  }

  closeDialog() {
    if (this.generating) return;
    this.dialog = false;
    this.progreso = 0;
    this.mensaje = "";
  }

  // Nuevo: enviar todos los QRS mapeados con ids al módulo para imprimir
  async imprimirSeleccionados() {
    try {
      const ids = (this.qrs || [])
        .map((item: any) => {
          const idNum = Number(item.id);
          return Number.isNaN(idNum) ? null : idNum;
        })
        .filter((x: number | null) => x !== null) as number[];

      if (!ids.length) {
        this.mensaje = "No hay QRS para imprimir.";
        return;
      }

      const payload = { ids };
      // llamar al método del módulo; asumo que devuelve una promesa
      await qrsModule.imprimirqrsSeleccionados(payload);
      this.mensaje = "Solicitud de impresión enviada.";
    } catch (err) {
      const msg = err && (err as Error).message ? (err as Error).message : String(err);
      this.mensaje = `Error al solicitar impresión: ${msg}`;
      console.error("imprimirSeleccionados error:", err);
    }
  }
  

  // Genera la cantidad solicitada y envía UNO a UNO usando qrsModule.guardarqrs
  async generarYEnviar() {
    if (!this.cantidad || this.cantidad <= 0) {
      this.mensaje = "Introduce una cantidad válida (>0).";
      return;
    }

    const MAX = 5000;
    if (this.cantidad > MAX) {
      this.mensaje = `Máximo permitido: ${MAX}. Reduce la cantidad.`;
      return;
    }

    this.generating = true;
    this.progreso = 0;
    this.mensaje = "Generando y enviando QRS...";
    this.errores = [];

    const baseTimestamp = Date.now();
    for (let i = 0; i < this.cantidad; i++) {
      // crear objeto qrs con la estructura proporcionada
      const code = `QR-${baseTimestamp}-${i}-${Math.random()
        .toString(36)
        .slice(2, 8)}`;
      const nuevoQrs = new qrs({
        // siguiendo la clase proporcionada:
        code: code,
        prize_text: "",
        has_prize: false,
        redeemed: false,
        redeemed_at: new Date("1900-01-01T00:00:00Z"), // fecha muy atrás; el módulo/servidor puede convertirla si necesita string
      });

      try {
        await qrsModule.guardarqrs(nuevoQrs);
      } catch (err) {
        const msg =
          err && (err as Error).message ? (err as Error).message : String(err);
        this.errores.push(`#${i + 1} (${code}): ${msg}`);
        // continuar con los siguientes
      }

      // actualizar progreso y permitir render
      this.progreso = Math.round(((i + 1) / this.cantidad) * 100);
      // evitar bloquear la UI excesivamente
      if (i % 10 === 0) {
        // permitir repaint
        // eslint-disable-next-line no-await-in-loop
        await this.$nextTick();
      }
    }

    // refrescar listados
    try {
      if (qrsModule && typeof qrsModule.getqrses === "function") {
        await qrsModule.getqrses();
      }
    } catch {
      // ignore
    }

    // resultado final
    if (this.errores.length === 0) {
      this.mensaje = `Se han generado y guardado ${this.cantidad} QRS correctamente.`;
    } else {
      this.mensaje = `Generados: ${
        this.cantidad - this.errores.length
      }. Errores: ${
        this.errores.length
      }. Revisa la consola o la lista de errores.`;
      console.error("Errores al guardar QRS:", this.errores);
    }

    // pequeño retardo para que el usuario vea el resultado
    setTimeout(() => {
      this.generating = false;
      this.dialog = false;
      this.progreso = 0;
    }, 900);
  }

  // Nuevo: abre el popup de edición con los datos recibidos desde la tabla
  editar_caja(item: any) {
    if (!item) return;
    // clonar para evitar mutaciones directas en la lista
    const copia = new qrs({
      id: item.id,
      code: item.code,
      prize_text: item.prize_text,
      has_prize: !!item.has_prize,
      redeemed: !!item.redeemed,
      redeemed_at: item.redeemed_at
        ? new Date(item.redeemed_at)
        : new Date("1900-01-01T00:00:00Z"),
    });
    this.editQrs = copia;
    this.editMensaje = "";
    this.editDialog = true;
  }

  // Nuevo: guardar cambios de edición
  async guardarEdicion() {
    if (!this.editQrs) return;
    this.editSaving = true;
    this.editMensaje = "Guardando...";

    // actualizar redeemed_at según estado redeemed
    if (this.editQrs.redeemed) {
      // si ya tiene fecha válida, mantenerla; si no, poner ahora
      if (
        !this.editQrs.redeemed_at ||
        new Date(this.editQrs.redeemed_at).getFullYear() < 2000
      ) {
        this.editQrs.redeemed_at = new Date();
      }
    } else {
      // desmarcado -> fecha atrás por convención
      this.editQrs.redeemed_at = new Date("1900-01-01T00:00:00Z");
    }

    try {
      await qrsModule.modificarqrs(this.editQrs);
      // refrescar listado
      if (qrsModule && typeof qrsModule.getqrses === "function") {
        await qrsModule.getqrses();
      }
      this.editMensaje = "Guardado correctamente.";
      // cerrar con pequeño retardo
      setTimeout(() => {
        this.editDialog = false;
        this.editQrs = null;
        this.editMensaje = "";
      }, 600);
    } catch (err) {
      const msg =
        err && (err as Error).message ? (err as Error).message : String(err);
      this.editMensaje = `Error: ${msg}`;
      console.error("Error al guardar edición QRS:", err);
    } finally {
      this.editSaving = false;
    }
  }

  cancelarEdicion() {
    if (this.editSaving) return;
    this.editDialog = false;
    this.editQrs = null;
    this.editMensaje = "";
  }
}
